<template>
  <div class="race-question">
    <modal name="addLuckyRunner" @before-close="onClose" class="addLuckyRunner" :adaptive="true" :scrollable="true" height="auto" width="80%" maxWidth="500">
      <div style="padding: 20px;">
        <h3>Add LuckyLiveRunner</h3>
        <div class="errorMsg" v-if="invalidError">{{invalidMsg}}</div>
      <div class="form-data-outer">
        <div class="form-data">
          <label>Race Id</label>
          <input v-model="luckyRunnerData.raceId"  @change="changeHandle">          
        </div>
         <div class="form-data">
          <label>Runner Id </label>
          <input v-model="luckyRunnerData.runnerId" @change="changeHandle">         
        </div>
        <div class="form-data">
          <label>Sent</label>       
          <date-field  v-model="luckyRunnerData.presentSentDate"  name="presentSentDate">
          </date-field>
        </div>

        <div class="form-data">
          <label>What</label>
            <input v-model="luckyRunnerData.presentContent">          
        </div>

        <div class="form-data">
          <label>Note</label>
          <textarea v-model="luckyRunnerData.note"></textarea>
        </div>

      <div class="saveBtn">
        <button class="btn btn--primary" v-on:click="Save()" style="float:none">Save</button>
      </div>

        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue"
import RacesService from "../../../services/races"
import LuckyLiveRunnerService from "../../../services/luckyLiveRunner"
import RunnersByRaceService from "../../../services/runnersByRace"
import DateField from '@/components/Forms/DateField'
import { db } from "../../../firebase"
import EventBus from '../../../eventBus'

export default {
  name: "add-lucky-live-runner",
  data: () => ({
   luckyRunnerData:{
      "raceId":'',
      "runDate": "",
      "runName": "",
      "trainerName": "",
      "runStartTime": "",
      "runnerId": '',
      "runnerName": "",
      "presentSentDate": "",
      "presentContent": "",
      "note": ''
    },
    invalidError:false,
    invalidMsg:''
  }),
  props: {
    show: false
  },
  methods: {
    changeHandle(){
      this.invalidError=false
      this.invalidMsg=""
    },
    onClose() {
      //EventBus.$emit('date','true')
      this.luckyRunnerData={
      "raceId":'',
      "runDate": "",
      "runName": "",
      "trainerName": "",
      "runStartTime": "",
      "runnerId": '',
      "runnerName": "",
      "presentSentDate": "",
      "presentContent": "",
      "note": ''
    }
      this.$emit("closed", true)
    },
    openAddModal() {
      //this.luckyRunnerData.presentSentDate=""
      this.showError(false,"")
      this.$modal.show('addLuckyRunner')
    },
    showError(error,msg){
      this.invalidError=error
      this.invalidMsg=msg
    },
    Save() {
      var that = this
      if(this.luckyRunnerData.raceId!='' && this.luckyRunnerData.runnerId!=''){
        RacesService.get(this.luckyRunnerData.raceId).then((response) => {
          var raceData = response.data
          this.showError(false,"")
          that.luckyRunnerData.runDate= raceData.date.split("T")[0]
          that.luckyRunnerData.runName= raceData.name
          that.luckyRunnerData.trainerName=raceData.trainer.firstName
          that.luckyRunnerData.runStartTime= raceData.date.split("T")[1].split(":")[0] +":"+ raceData.date.split("T")[1].split(":")[1]
          that.luckyRunnerData.raceDateTime= raceData.date

          RunnersByRaceService.getByRunnerId(that.luckyRunnerData.runnerId).then(async (resp)=>{
            var runnerData = resp.data
            this.showError(false,"")
            that.luckyRunnerData.runnerName= runnerData.runner.firstName
            console.log("this.luckyRunnerData---",that.luckyRunnerData)
            LuckyLiveRunnerService.create(that.luckyRunnerData).then(response => {
              //this.$emit('saved', response.data)
              this.showError(false,"")
              this.$emit('saved')
              this.$modal.hide('addLuckyRunner')            
            }).catch(error => {
              console.log("err---",error)
              this.showError(true,error.data.description)
              //this.$modal.hide('addLuckyRunner')
            }) 
          }).catch(error => {
            console.log("err---",error)
            this.showError(true,"Invalid RunnerId !") 
          })
          
        }).catch(error => {
            console.log("err---",error) 
            this.showError(true,"Invalid RaceId !") 
        })  
      }else{
        this.luckyRunnerData.raceId==''?this.showError(true,"Invalid RaceId !"):this.showError(true,"Invalid RunnerId !")
      }

               
    }
  },
  created() {
    //this.$watch("show", function(val) {})
  },

  watch: {
    show(oldVal, newVal) {
      if (this.show) {
        this.openAddModal()
      }
    }
  },
  components: {
    DateField
  }
}
</script>
<style>
.addLuckyRunner .sweet-title {
    text-align: center;
    color: #423799;
}
.addLuckyRunner .sweet-modal {
  border-radius: 30px;
  border: 2px solid #ccc;
}
/* .addLuckyRunner .sweet-content-content label {
    width: 100%;
    display: inline-block;
    margin-bottom:20px;
} */
.addLuckyRunner .sweet-content-content input {
    width: 70%;
    border-radius: 15px;
    border: 1px solid #ccc;
    padding: 0px 15px;
    height: 45px;
    font-size: 20px;
}
.addLuckyRunner .form-data-outer {
    padding: 0px 60px 0 60px;
}
.addLuckyRunner .sweet-content-content textarea {
    width: 70%;
    border-radius: 15px;
    border: 1px solid #ccc;
    padding: 12px 15px;
    min-height:90px;
}
.addLuckyRunner .errorMsg {
  padding: 10px;
  color: red;
  text-align: center;
}
.addLuckyRunner .sweet-modal.is-alert .sweet-content{padding:0 5px;}
.addLuckyRunner .sweet-content-content label {     
    float: left;
    width: 25%;
    margin-top: 11px;
    font-size: 18px;
    margin-right: 10px;
    color: #3e3c3c;
}
.addLuckyRunner .saveBtn{
  text-align: center
}
.addLuckyRunner .form-data {
    margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// AddLuckyLiveRunner.vue?3256f5a5